import { render } from "./productBox.vue?vue&type=template&id=295ca800"
import script from "./productBox.vue?vue&type=script&lang=js"
export * from "./productBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__